module.exports = __webpack_public_path__ + "static/media/lv.0b4e6e1a.svg";